module.exports = __webpack_public_path__ + "img/live_cover.be8ff123.png";